import styled from '@emotion/styled';
import { Divider } from 'antd';
// import Paragraph from 'antd/lib/typography/Paragraph';
// import { IInspection } from 'app/types/interfaces/Inspection';
// import { urlify } from 'app/utils';
import React from 'react';
import { ReactComponent as ArrowRightSvg } from 'assets/icons/ArrowRight.svg';
import { InfoLine, Status } from '../Elements';
import classes from './OverallInfo.module.scss';

const StyledWrapper = styled.div`
  > div.ant-space {
    margin-bottom: 10px;
    
  }
  > div.ant-divider {
    margin-top: 14px;
  }
  .ant-space {
    .ant-space-item:last-of-type {
      line-height: 22px;
    }
  }
`;
const OverallInfo = (props: {
  issuedBy: string;
  conclusion: string;
  submitDate: string;
  inspectionDate: string;
  esign?: boolean;
  onViewEsign?: () =>  void;
}) => {
  return (
    <StyledWrapper>
      <InfoLine label="Issued by:" value={props?.issuedBy || 'N/A'}></InfoLine>
      <InfoLine
        label="Overall Report Result:"
        value={<Status status={props.conclusion as any}></Status>}
      ></InfoLine>
      <Divider></Divider>
      <InfoLine
        label="Submitted Date:"
        value={props.submitDate || 'N/A'}
      ></InfoLine>
      <InfoLine
        label="Inspection Date:"
        value={props.inspectionDate || 'N/A'}
      ></InfoLine>
      <InfoLine
        className={classes.eSignatureBlock}
        label="E-signature:"
        value={<>{props.esign ? <span className={classes.signedBlock}><span>Signed</span><span onClick={props.onViewEsign}>View<ArrowRightSvg /></span></span> : 'Not signed yet'}</>}
      ></InfoLine>
      <Divider></Divider>
    </StyledWrapper>
  );
};

export default OverallInfo;
